import { useHistory, useLocation } from 'quartz-routing/react-router';
import { useCallback } from 'react';
const useNavigate = () => {
  const history = useHistory();
  const location = useLocation();
  const navigate = useCallback((input, {
    method
  } = {
    method: 'push'
  }) => {
    if (typeof input === 'string') {
      history[method](input);
    } else if (typeof input === 'number') {
      history.go(input);
    } else if (typeof input === 'function') {
      history[method](input(location));
    } else {
      history[method](input);
    }
  }, [history, location]);
  return navigate;
};
export default useNavigate;